import { _ as _defineProperty } from '../defineProperty-Y-S4SptN.js';
import { _ as _slicedToArray } from '../slicedToArray-ibbgR3-O.js';
import { forwardRef, useState, useCallback } from 'react';
import Input from '../Input/index.js';
import { I as InputSize } from '../types-arAyTUq_.js';
import RangeSlider from '../RangeSlider/index.js';
import noop from '../noop/index.js';
import validateInputRange from '../validateInputRange/index.js';
import createUseStyles from '../create/index.js';
import { j as jsxRuntimeExports } from '../jsx-runtime-KJzvSKZ_.js';

var Appearance = /*#__PURE__*/function (Appearance) {
  Appearance["Default"] = "default";
  Appearance["Info"] = "info";
  return Appearance;
}({});

var useStyles = createUseStyles({
  inputRangeWrapper: {
    width: '100%'
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: function marginBottom(_ref) {
      var displayRange = _ref.displayRange;
      return displayRange && 9;
    }
  },
  labelWidth: {
    width: 54,
    flex: 'none',
    marginLeft: 12
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 13
  },
  input: {
    textAlign: 'center'
  },
  header: {
    fontSize: 12,
    color: 'var(--texts-tint-1)'
  },
  footer: {
    fontSize: 10,
    marginTop: 9,
    color: 'var(--texts-tint-1)',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function InputRange(_ref,
// ref will be passed to input number component
ref) {
  var _ref2;
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? 0 : _ref$defaultValue,
    value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    inputProps = _ref.inputProps,
    rangeProps = _ref.rangeProps,
    _ref$displayRange = _ref.displayRange,
    displayRange = _ref$displayRange === void 0 ? false : _ref$displayRange,
    _ref$apperance = _ref.apperance,
    apperance = _ref$apperance === void 0 ? Appearance.Default : _ref$apperance,
    header = _ref.header,
    validate = _ref.validate;
  var styles = useStyles({
    displayRange: displayRange
  });
  var _useState = useState(validateInputRange(min, max, value || defaultValue)),
    _useState2 = _slicedToArray(_useState, 2),
    localValue = _useState2[0],
    setLocalValue = _useState2[1];
  var onChangeHandler = useCallback(function (event) {
    var val = event.target.value;
    if (val.startsWith('--') || val === '--') return;
    if (!validate && val !== '-' && val !== '') {
      val = Number(val).toString(); // remove 0 from start
    }
    value === undefined && setLocalValue(validate ? validate(val) : val);
    onChange(event);
  }, [validate, value, onChange]);
  var onBlurHandler = useCallback(function (e) {
    value === undefined && setLocalValue(validateInputRange(min, max, Number(e.target.value)));
    onBlur(e, validateInputRange(min, max, Number(e.target.value)));
  }, [value, min, max, onBlur]);
  var inputComponent = /*#__PURE__*/jsxRuntimeExports.jsx(Input, _objectSpread({
    ref: ref,
    rootClassName: styles.labelWidth,
    className: styles.input,
    value: value !== null && value !== void 0 ? value : localValue,
    onChange: onChangeHandler,
    onBlur: onBlurHandler,
    size: InputSize.Sm,
    min: min,
    max: max,
    type: "number"
  }, inputProps));
  return /*#__PURE__*/jsxRuntimeExports.jsxs("div", {
    className: styles.inputRangeWrapper,
    children: [apperance === Appearance.Info && /*#__PURE__*/jsxRuntimeExports.jsxs("div", {
      className: styles.top,
      children: [/*#__PURE__*/jsxRuntimeExports.jsx("div", {
        className: styles.header,
        children: header
      }), inputComponent]
    }), /*#__PURE__*/jsxRuntimeExports.jsxs("div", {
      className: styles.root,
      children: [/*#__PURE__*/jsxRuntimeExports.jsx(RangeSlider, _objectSpread({
        min: min,
        max: max,
        step: step,
        onChange: onChangeHandler,
        value: value === '-' ? min : (_ref2 = value) !== null && _ref2 !== void 0 ? _ref2 : localValue,
        ref: ref,
        defaultValue: defaultValue
      }, rangeProps)), !(apperance === Appearance.Info) && inputComponent]
    }), apperance === Appearance.Info && /*#__PURE__*/jsxRuntimeExports.jsxs("div", {
      className: styles.footer,
      children: [/*#__PURE__*/jsxRuntimeExports.jsx("span", {
        children: min
      }), /*#__PURE__*/jsxRuntimeExports.jsx("span", {
        children: max
      })]
    })]
  });
}
var InputRange$1 = /*#__PURE__*/forwardRef(InputRange);

export { Appearance, InputRange$1 as default };
//# sourceMappingURL=index.js.map
